import { render, staticRenderFns } from "./Instances.vue?vue&type=template&id=3e8214d4&scoped=true&"
import script from "./Instances.vue?vue&type=script&lang=js&"
export * from "./Instances.vue?vue&type=script&lang=js&"
import style0 from "./Instances.vue?vue&type=style&index=0&id=3e8214d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8214d4",
  null
  
)

export default component.exports